<app-page-header
  title="Visual Narrative Maker"
  [subtitle]="i18n.t('vnm.subtitle')"
  [icons]="headerIcons">
</app-page-header>

<!-- 進捗サマリーバー -->
<div
  class="progress-summary"
  *ngIf="currentState.isGeneratingImages || currentState.isGeneratingVideos || currentState.isCombiningVideos"
>
  <div class="progress-content">
    <div class="progress-text">
      <span *ngIf="currentState.isGeneratingImages">{{ i18n.t('vnm.generatingImages') }}</span>
      <span *ngIf="!currentState.isGeneratingImages && currentState.isGeneratingVideos">{{ i18n.t('vnm.generatingVideos') }}</span>
      <span *ngIf="!currentState.isGeneratingImages && !currentState.isGeneratingVideos && currentState.isCombiningVideos">{{ i18n.t('vnm.combiningVideos') }}</span>
    </div>
    <div class="progress-bar-container">
      <div
        class="progress-bar"
        [style.width.%]="
          currentState.isGeneratingImages
            ? currentState.imageGenerationProgress
            : currentState.isGeneratingVideos
              ? currentState.videoGenerationProgress
              : 100"
      ></div>
    </div>
  </div>
</div>

<div class="container">
  <div class="content-area">
    <div class="left-panel">
      <form [formGroup]="videoForm">
        <div class="project-info">
          <!-- CSV アップロード -->
          <app-narrative-csv-uploader
            (scenesLoaded)="onScenesLoaded($event)"
            (uploadError)="onCSVUploadError($event)">
          </app-narrative-csv-uploader>

          <!-- スタイル設定 -->
          <app-narrative-style-config
            [config]="currentState.styleConfig"
            (configChange)="onStyleConfigChange($event)"
            (styleImageUploaded)="onStyleImageUploaded($event)"
            (styleImageRemoved)="onStyleImageRemoved()"
            (validationError)="onValidationError($event)">
          </app-narrative-style-config>
        </div>

        <div class="action-buttons top-actions">
          <button
            type="button"
            class="spectrum-button spectrum-button--primary"
            (click)="generateSceneImages()"
            [disabled]="currentState.isGeneratingImages || !videoForm.valid"
          >
            {{ currentState.isGeneratingImages ? i18n.t('vnm.generatingBtn') : i18n.t('vnm.generateSceneImages') }}
          </button>

          <button
            type="button"
            class="spectrum-button spectrum-button--primary"
            (click)="generateVideoFromImages()"
            [disabled]="
              !areAllSceneImagesGenerated() || 
              currentState.isGeneratingImages || 
              currentState.isGeneratingVideos
            "
          >
            {{ currentState.isGeneratingVideos ? i18n.t('vnm.generatingVideoBtn') : i18n.t('vnm.generateVideo') }}
          </button>

          <button 
            type="button" 
            class="spectrum-button spectrum-button--primary" 
            (click)="regenerateCombinedVideo()" 

            [disabled]="!hasMultipleSceneVideos() || currentState.isCombiningVideos || currentState.isGeneratingVideos">
            {{ currentState.isCombiningVideos ? i18n.t('vnm.combiningBtn') : i18n.t('vnm.combineVideo') }}
          </button>
        </div>
      </form>
    </div>

    <div class="right-panel">
      <div class="tab-navigation">
        <button
          class="tab-button"
          [class.active]="activeTab === 'scenes'"
          (click)="activeTab = 'scenes'"
        >
          {{ i18n.t('vnm.tabScenes') }}
        </button>
        <button
          class="tab-button"
          [class.active]="activeTab === 'combined'"
          (click)="activeTab = 'combined'"
          [disabled]="!currentState.combinedVideoUrl"
        >
          {{ i18n.t('vnm.tabCombined') }}
        </button>
      </div>

      <!-- タブコンテンツ -->
      <div class="tab-content">
        <!-- シーンプレビュータブ -->
        <div class="tab-pane" *ngIf="activeTab === 'scenes'">
          <div class="preview-container">
            <!-- シーンプレビューは常に表示 -->
            <div class="scenes-preview" *ngIf="currentState.scenes.length > 0">
              <div
                *ngFor="let scene of currentState.scenes; let i = index; trackBy: trackBySceneId"
                class="scene-card">
                
                <!-- シーン情報とフォーム -->
                <div class="scene-header">
                  <h4>{{ i18n.t('vnm.sceneN', { n: i + 1 }) }}</h4>
                  <div class="scene-actions">
                    <button 
                      type="button" 
                      class="settings-button"
                      (click)="toggleSceneVideoSettings(i)"
                      [title]="i18n.t('vnm.detailSettings')">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M19.14,12.94c0.04-0.3,0.06-0.61,0.06-0.94c0-0.32-0.02-0.64-0.07-0.94l2.03-1.58c0.18-0.14,0.23-0.41,0.12-0.61 l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39,0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.4,2.81c-0.04-0.24-0.24-0.41-0.48-0.41 h-3.84c-0.24,0-0.43,0.17-0.47,0.41L9.25,5.35C8.66,5.59,8.12,5.92,7.63,6.29L5.24,5.33c-0.22-0.08-0.47,0-0.59,0.22L2.74,8.87 C2.62,9.08,2.66,9.34,2.86,9.48l2.03,1.58C4.84,11.36,4.8,11.69,4.8,12s0.02,0.64,0.07,0.94l-2.03,1.58 c-0.18,0.14-0.23,0.41-0.12,0.61l1.92,3.32c0.12,0.22,0.37,0.29,0.59,0.22l2.39-0.96c0.5,0.38,1.03,0.7,1.62,0.94l0.36,2.54 c0.05,0.24,0.24,0.41,0.48,0.41h3.84c0.24,0,0.44-0.17,0.47-0.41l0.36-2.54c0.59-0.24,1.13-0.56,1.62-0.94l2.39,0.96 c0.22,0.08,0.47,0,0.59-0.22l1.92-3.32c0.12-0.22,0.07-0.47-0.12-0.61L19.14,12.94z M12,15.6c-1.98,0-3.6-1.62-3.6-3.6 s1.62-3.6,3.6-3.6s3.6,1.62,3.6,3.6S13.98,15.6,12,15.6z"/>
                      </svg>
                    </button>
                    <button 
                      type="button" 
                      class="regenerate-button"
                      (click)="regenerateSceneImage(i)"
                      [disabled]="isRegeneratingSceneImage[i] || currentState.isGeneratingImages"
                      [title]="i18n.t('vnm.regenerateImage')">
                      {{ i18n.t('vnm.regenerateImage') }}
                    </button>
                    <button 
                      type="button" 
                      class="regenerate-button"
                      (click)="regenerateSceneVideo(i)"
                      [disabled]="isRegeneratingSceneVideo[i] || currentState.isGeneratingVideos || !scene.images.length"
                      [title]="i18n.t('vnm.regenerateVideo')">
                      {{ i18n.t('vnm.regenerateVideo') }}
                    </button>
                    <button 
                      type="button" 
                      class="remove-scene-button"
                      (click)="removeScene(i)"
                      [disabled]="currentState.scenes.length <= 1"
                      [title]="i18n.t('vnm.deleteScene')">
                      {{ i18n.t('vnm.delete') }}
                    </button>
                  </div>
                </div>

                <div class="scene-content" [formGroup]="getFormGroup(i)">
                  <!-- プロンプト入力と動画設定 -->
                  <div class="scene-details" *ngIf="!sceneVideoSettingsExpanded[i]">
                    <!-- プロンプト入力 -->
                    <div class="scene-info">
                      <div class="form-group">
                        <label>{{ i18n.t('vnm.prompt') }}</label>
                        <textarea
                          formControlName="prompt"
                          (input)="updateScenePrompt(i, $any($event.target).value)"
                          class="form-control form-control-lg"
                          [placeholder]="i18n.t('vnm.promptPlaceholder')">
                        </textarea>
                      </div>
                      <div class="form-group">
                        <label>{{ i18n.t('vnm.negativePrompt') }}</label>
                        <textarea
                          formControlName="negative_prompt"
                          (input)="updateSceneNegativePrompt(i, $any($event.target).value)"
                          class="form-control"
                          [placeholder]="i18n.t('vnm.negativePromptPlaceholder')">
                        </textarea>

                        <label>{{ i18n.t('vnm.cameraMotion') }}</label>
                        <app-video-settings-camera-only
                          [ngModel]="scene.videoSettings || {cameraMotion: ''}"
                          (ngModelChange)="onSceneVideoSettingsChanged(i, $event)"
                          [ngModelOptions]="{standalone: true}"
                          [disabled]="false"
                          name="sceneVideoSettings_{{i}}">
                        </app-video-settings-camera-only>
                      </div>
                    </div>
                  </div>

                  <!-- 画像と動画を同じ高さで表示 -->
                  <div class="scene-media">
                    <div class="media-section image-section">
                      <h5>{{ i18n.t('vnm.generatedImage') }}</h5>
                      <div class="media-content">
                        <img
                          *ngIf="scene.images && scene.images.length > 0"
                          [src]="getSelectedImageUrl(i)"
                          [alt]="i18n.t('vnm.sceneImageAlt', { n: i + 1 })"
                        />
                        <img
                          *ngIf="!scene.images || scene.images.length === 0"
                          src="./assets/placeholder-image.jpg"
                          [alt]="i18n.t('vnm.placeholder')"
                        />
                      </div>

                      <!-- サムネイル -->
                      <div
                        *ngIf="scene.images && scene.images.length > 0"
                        class="image-thumbnails"
                      >
                        <div
                          *ngFor="let image of scene.images; let j = index"
                          class="thumbnail"
                          [class.active]="scene.selectedImageIndex === j"
                          (click)="onImageSelected(i, j)"
                        >
                          <img [src]="image.url" [alt]="i18n.t('vnm.variationAlt', { n: j + 1 })" />
                        </div>
                      </div>
                    </div>

                    <!-- 動画セクション -->
                    <div
                      class="media-section video-section"
                      *ngIf="scene.video"
                    >
                      <h5>{{ i18n.t('vnm.generatedVideo') }}</h5>
                      <div class="media-content">
                        <video
                          controls
                          [src]="scene.video.url"
                          class="scene-video-player"
                        ></video>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- シーン追加ボタン -->
              <div class="add-scene-section">
                <button 
                  type="button" 
                  class="spectrum-button spectrum-button--secondary add-scene-button"
                  (click)="addScene()">
                  {{ i18n.t('vnm.addScene') }}
                </button>
              </div>
            </div>

            <!-- 空の状態 -->
            <div *ngIf="currentState.scenes.length === 0" class="empty-state">
              <svg
                width="64"
                height="64"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <p>{{ i18n.t('vnm.emptyHint') }}</p>
              <p class="sub-text">
                {{ i18n.t('vnm.emptySubHint') }}
              </p>
            </div>
          </div>
        </div>

        <!-- 結合動画タブ -->
        <div class="tab-pane" *ngIf="activeTab === 'combined'">
          <div class="combined-video-container">
            <div class="video-player-wrapper">
              <video
                controls
                [src]="currentState.combinedVideoUrl"
                class="combined-video-player"
              ></video>
            </div>

            <div class="video-actions">
              <button 
                type="button" 
                class="spectrum-button spectrum-button--primary"
                (click)="editCombinedVideo()"
                [disabled]="!currentState.combinedVideoUrl">
                {{ i18n.t('vnm.editVideo') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-toast></app-toast>